import { TidLocale } from '../models/tid-locale';
import { trimbleIdentityEnvironment } from '../trimble-identity-environment';

/**
 * Redirect window to TID
 * @param client_id Application Client ID on Trimble Cloud
 * @param applicationName Application Name on Trimble Cloud
 * @param redirectUrl Whitelisted Callback URL on Trimble Cloud
 * @param prompt 'create', 'login', or 'none'
 * @param email email to prepopulate TID page (Optional)
 * @param state state to return to application on redirect (Optional)
 * @param identityProvider use this to redirect to a specific federated identity provider (Optional)
 * @param uiLocales set the locale. Omitting this will default to the user's browser locale (Optional)
 */
export function redirectToTid(request: {
  applicationName: string;
  client_id: string;
  email?: string;
  identityProvider?: string;
  prompt: 'create' | 'login' | 'none';
  redirectUrl: string;
  state?: Record<string, unknown> | string;
  uiLocales?: TidLocale;
}) {
  const params = new URLSearchParams();
  params.append('client_id', request.client_id);
  params.append('response_type', 'code');
  params.append('scope', `openid ${request.applicationName}`);
  params.append('redirect_uri', request.redirectUrl);
  params.append('prompt', request.prompt);

  if (typeof request.email === 'string') {
    params.append('login_hint', request.email);
  }

  if (typeof request.state !== 'undefined') {
    const state =
      typeof request.state === 'string'
        ? request.state
        : JSON.stringify(request.state);
    params.append('state', state);
  }

  if (typeof request.identityProvider !== 'undefined') {
    params.append('identity_provider', request.identityProvider);
  }

  if (typeof request.uiLocales !== 'undefined') {
    params.append('ui_locales', request.uiLocales);
  }

  const url = `${trimbleIdentityEnvironment.authorizeUrl}?${params.toString()}`;
  window.location.href = url;
}
